var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTierinfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "20px",
    viewBox: "0 0 40 20",
    enableBackground: "new 0 0 40 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 40,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M20,19c4.971,0,9-4.029,9-9c0-4.971-4.029-9-9-9c-4.971,0-9,4.029-9,9 C11,14.971,15.029,19,20,19"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    d: "M20,8c0,0-1.5,0-1.5,1.5v5c0,0,0,1.5,1.5,1.5c0,0,1.5,0,1.5-1.5v-5 C21.5,9.5,21.5,8,20,8"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    d: "M20,6.325c0.87,0,1.575-0.705,1.575-1.575S20.87,3.175,20,3.175 S18.425,3.88,18.425,4.75S19.13,6.325,20,6.325"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTierinfo);
export default __webpack_public_path__ + "static/media/tierinfo.6ff6f3866260eb16e5182a9f53ef2051.svg";
export { ForwardRef as ReactComponent };